// extracted by mini-css-extract-plugin
export default {"root":"AddMenuButton_root__VtJBC","button":"AddMenuButton_button__bAFtj","icon":"AddMenuButton_icon__g0e61","text":"AddMenuButton_text__-FVtW"};